import { config } from './config.ts';

/** Where the public API of this deployment answers (shown next to the API keys). */
export const publicApiUrl = (): string => `${window.location.origin}${config.basePath}/api/v1`;
